import DrawButton from '../DrawButton/DrawButton';
import { BOX, POLYGON, LINE } from 'client/utils/constants/symbolName';
import { shallowEqual, useSelector } from 'react-redux';
import mapModeIsValid from '../validateModes';
import { VALID_MODES } from '../DrawButton/DrawButton.mode';
import { selectMapMode } from 'client/store/mapSlice/mapSlice';
import DropdownButton from 'client/components/aria/DropdownButton/DropdownButton';
import { mapModes } from 'client/utils/constants/appStates';
import { selectDrawStatus, selectDrawType } from 'client/store/drawSlice/drawSlice';
import { linearSearchFeatureFlag } from 'client/utils/constants/frontEndConfig';

const { DRAWING, LOADING, MODIFYING } = mapModes;

const options = [
    BOX,
    POLYGON,
    ...linearSearchFeatureFlag ? [LINE] : []
];

const DrawButtonDropdown = () => {
    const mapMode = useSelector(selectMapMode, shallowEqual);
    const drawStatus = useSelector(selectDrawStatus, shallowEqual);
    const show = mapModeIsValid(mapMode, VALID_MODES);
    const isActivelyEditingAoi = mapMode.includes(DRAWING) || mapMode.includes(MODIFYING);
    const isDisabled = isActivelyEditingAoi || mapMode.includes(LOADING) || (drawStatus.length > 0 && isActivelyEditingAoi);
    const drawType = useSelector(selectDrawType);

    const selectedIndex = Math.max(0, options.indexOf(drawType));

    if (!show) {
        return null;
    }

    return (
        <>
            <DropdownButton
                isDisabled={isDisabled}
                selectedIndex={selectedIndex}
                variant='info'
                data-testid="mapToolBar.draw.dropdown"
            >
                {options.map((option) => (
                    <DrawButton
                        variant='info'
                        key={option}
                        type={option}
                        tabIndex={-1}
                    />
                ))}
            </DropdownButton>
        </>
    );
};

export default DrawButtonDropdown;
